export const fetchJsonAds = async (object, num, chash, show_id, utm_term) => {
    if (!object) {
        return { news: [], billingNoticeUrl: null };
    }
    try {
        let url = `https://ssp.24smi.net/rtb/v2/ad?object=${object}&output=json&num=${num}&chash=${chash}&show_id=${show_id}`;
        if (utm_term) {
            url += `&subid_source=${encodeURIComponent(utm_term)}`;
        }
        const response = await fetch(url);
        const data = await response.json();
        return {
            news: data.news,
            billingNoticeUrl: data.settings && data.settings.billingNoticeUrl
        };
    } catch (error) {
        console.error('Error fetching the data:', error);
        return {
            news: [],
            billingNoticeUrl: null
        };
    }
}
